export default "__VITE_ASSET__CFRYr_Uo__"